import React from 'react';
import { MainPageLayout } from '../layout/MainPageLayout';
import { AuthHelpDiv } from '../component/auth-help/AuthHelpDiv';

export const AuthHelpPage = () => (
  <MainPageLayout elementCentr={<AuthHelpDiv />} />
);
